import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/Layout';
import './Unauthorized.css';

const Unauthorized = () => {
  return (
    <Layout 
      title="権限エラー"
    >
      <div className="unauthorized-container">
        <div className="unauthorized-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </div>
        <h2>アクセス権限がありません</h2>
        <p>このページを表示するための権限が不足しています。</p>
        <p>アクセス権限について質問がある場合は、管理者にお問い合わせください。</p>
        <div className="unauthorized-actions">
          <Link to="/" className="primary-button">
            ホームに戻る
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default Unauthorized; 